import { message, Layout, Modal, List, Typography } from "antd";
import React, { useContext, useEffect, useState } from "react";
import FormOnboarding from "../components/FormOnboarding";
import { getNextSezione, getSezione, getSezioni, setSezione, setSezioneUpload } from "../services/api";
import logo from "./../assets/img/BAIndipendenti.png"
import { LoadingOutlined, CaretDownOutlined, HomeOutlined, FileTextOutlined, CaretUpOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ReactComponent as SvgDoc } from "./../assets/svg/SvgDoc.svg";
import { ReactComponent as SvgOnboarding } from "./../assets/svg/SvgOnboarding.svg";
import logo2 from "./../assets/img/BAbianco.png"
import { DocInformativi } from "../utils/constants";
const { Content, Sider, Header } = Layout;
const { innerWidth, innerHeight } = window;

const OnboardingScreen = () => {
    const [regole, setRegole] = useState();
    const [headerSezione, setheaderSezione] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingSezioni, setLoadingSezioni] = useState(false);
    const [loadingSetSezioni, setLoadingSetSezioni] = useState(false);
    const [sezioniMobile, setSezioniMobile] = useState(false);
    const [stopScroll, setStopScroll] = useState(false);
    const [sezioni, setSezioni] = useState([]);
    const [sezioneCompiled, setSezioneCompiled] = useState();
    const [campo, setCampo] = useState();
    const [file, setFile] = useState();
    const [flgRecupero, setFlgRecupero] = useState();
    const [polContentHeight, setPolContentHeight] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        fetchRegole();
        fetchSezioni();
        let height = '';
        if (localStorage.getItem('nomeOperatore')) {
            height = "calc(100vh - 64px)";
        }
        else {
            if (innerWidth < 800)
                height = '90vh';
            else
                height = '100vh';
        }
        setPolContentHeight(height)
    }, []);

    useEffect(() => {
        if (sezioniMobile) {
            setStopScroll(true);
        } else {
            setStopScroll(false);
        }
    }, [sezioniMobile]);

    useEffect(() => {
        if (sezioneCompiled) {
            setLoadingSetSezioni(true);
            const idPratica = localStorage.getItem('id_pratica');
            let d = {};
            if (campo) {
                d[campo] = sezioneCompiled;
            } else {
                d = sezioneCompiled;
            }
            let data = {
                id_sezione: headerSezione.id,
                id_pratica: idPratica,
                data: d
            }
            const token = localStorage.getItem('token');
            if (file) {
                setSezioneUpload(file, data, token)
                    .then((res) => {
                        if (res.next == 'end') {
                            setCampo();
                            if (localStorage.getItem('praticaTotem')) {
                                navigate('/completa');
                            }
                            else {
                                navigate('/overview');
                            }
                        } else if (res.next == true) {
                            fetchRegole();
                            fetchSezioni();
                            setCampo();
                        } else if (res.next == false) {
                            setRegole(res.items);
                            setCampo(res.campo);
                        }
                    })
                    .catch((error) => {
                        if (error == 'Non Autorizzato') {
                            navigate('/HomeScreen');
                        } else if (error == 'EX') {
                            Modal.error({
                                title: 'Errore nella verifica dei dati',
                                content: 'Si prega di riprovare controllando che i dati inseriti siano corretti',
                                onOk: () => window.location.reload()
                            });
                        }
                        else if (error?.codice && error.codice == 'ERB') {
                            Modal.error({
                                title: 'Errore durante il salvataggio dei dati',
                                content: error.message,
                                onOk: () => navigate('/HomeScreen')
                            });
                        }
                        else if (error?.codice && error.codice == 'BL') {
                            Modal.error({
                                title: 'Errore durante il salvataggio dei dati',
                                content: error.message,
                                onOk: () => navigate('/HomeScreen')
                            });
                        }  else if (error?.codice && error.codice == 'EXV') {
                            Modal.error({
                                title: 'Errore durante il salvataggio dei dati',
                                content: "Qualcosa non è andato come previsto. Riprova o contatta l'assistenza se il problema persiste.",
                                onOk: () => navigate('/HomeScreen')
                            });
                        } else if (error == 'PE') {
                            Modal.error({
                                title: 'Pratica In Corso',
                                content: 'E\' già presente una pratica in corso',
                                onOk: () => navigate('/HomeScreen')
                            });
                        } else if (error == 'SMS_OK') {
                            // message.info('L\'SMS è stato inviato correttamente.');
                            fetchRegole();
                        } else if (error.codice && error.codice == 'REC') {
                            localStorage.setItem("token", error.data.token);
                            localStorage.setItem("id_pratica", error.data.id_pratica);
                            fetchRegole();
                            fetchSezioni();
                            setCampo();
                        } else {
                            message.error(error);
                        }
                    })
                    .finally(() => {
                        setFile();
                        setLoadingSetSezioni(false);
                    });
            } else {
                setSezione(data, token)
                    .then((res) => {
                        if (res.next == 'end') {
                            setCampo();
                            if (localStorage.getItem('praticaTotem')) {
                                navigate('/completa');
                            }
                            else {
                                navigate('/overview');
                            }
                        } else if (res.next == true) {
                            fetchRegole();
                            fetchSezioni();
                            setCampo();
                        } else if (res.next == false) {
                            setRegole(res.items);
                            setCampo(res.campo);
                        }
                    })
                    .catch((error) => {
                        if (error == 'Non Autorizzato') {
                            navigate('/HomeScreen');
                        } else if (error == 'EX') {
                            Modal.error({
                                title: 'Errore nella verifica dei dati',
                                content: 'Si prega di riprovare controllando che i dati inseriti siano corretti',
                                onOk: () => window.location.reload()
                            });
                        }
                        else if (error?.codice && error.codice == 'ERB') {
                            Modal.error({
                                title: 'Errore durante il salvataggio dei dati',
                                content: error.message,
                                onOk: () => navigate('/HomeScreen')
                            });
                        }
                        else if (error?.codice && error.codice == 'BL') {
                            Modal.error({
                                title: 'Errore durante il salvataggio dei dati',
                                content: error.message,
                                onOk: () => navigate('/HomeScreen')
                            });
                        }
                        else if (error?.codice && error.codice == 'EXV') {
                            Modal.error({
                                title: 'Errore durante il salvataggio dei dati',
                                content: "Qualcosa non è andato come previsto. Riprova o contatta l'assistenza se il problema persiste.",
                                onOk: () => navigate('/HomeScreen')
                            });
                        }
                        
                        else if (error == 'PE') {
                            Modal.error({
                                title: 'Pratica In Corso',
                                content: 'E\' già presente una pratica in corso',
                                onOk: () => navigate('/HomeScreen')
                            });
                        }
                        else if (error == 'SMS_OK') {
                            // message.info('L\'SMS è stato inviato correttamente.')
                            fetchRegole();
                        }
                        else if (error.codice && error.codice == 'REC') {
                            localStorage.setItem("token", error.data.token);
                            localStorage.setItem("id_pratica", error.data.id_pratica);
                            fetchRegole();
                            fetchSezioni();
                            setCampo();
                        }
                        else {
                            if (Array.isArray(error)) {
                                error.forEach((item) => {
                                    message.error(item);
                                })
                            }
                        }
                    })
                    .finally(() => {
                        setLoadingSetSezioni(false);
                    });
            }
        }
    }, [sezioneCompiled]);

    const fetchRegole = async () => {
        setLoading(true);
        const idPratica = localStorage.getItem('id_pratica');
        let isMobile = false;
        if (/Android|iPhone/i.test(window.navigator.userAgent)) {
            isMobile = true;
        }
        const data = {
            id_pratica: idPratica,
            is_mobile: isMobile
        };
        const token = localStorage.getItem('token');
        getNextSezione(data, token)
            .then((response) => {
                if (response.next && response.next == 'end') {
                    setCampo();
                    if (localStorage.getItem('praticaTotem')) {
                        navigate('/completa');
                    }
                    else {
                        navigate('/overview');
                    }
                } else if (response.wait && response.wait == true) {
                    const cliente = response.cliente ? response.cliente : 'Gentile cliente'
                    navigate('/loading', { state: { cliente } });
                }
                else {
                    setRegole(response.items);
                    setheaderSezione(response.sezione);
                }
            })
            .catch((error) => {
                if (error == 'Non Autorizzato') {
                    navigate('/HomeScreen');
                } else {
                    message.error(error);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const fetchSezioni = async () => {
        setLoadingSezioni(true);
        const idPratica = localStorage.getItem('id_pratica');
        const data = {
            id_pratica: idPratica
        };
        const token = localStorage.getItem('token');
        getSezioni(data, token)
            .then((response) => {
                if (response.next && response.next == 'end') {
                    setCampo();
                    if (localStorage.getItem('praticaTotem')) {
                        navigate('/completa');
                    }
                    else {
                        navigate('/overview');
                    }
                } else {
                    setSezioni(response.data)
                }
                if (response.flg_recupero) {
                    setFlgRecupero(response.flg_recupero);
                }

            })
            .catch((error) => {
                if (error == 'Non Autorizzato') {
                    navigate('/HomeScreen');
                } else {
                    message.error(error);
                }
            })
            .finally(() => {
                setLoadingSezioni(false);
            });
    };

    const sezioneHandler = async (idSezione) => {
        setLoading(true);
        const idPratica = localStorage.getItem('id_pratica');
        const data = {
            id_pratica: idPratica,
            id_sezione: idSezione
        };
        const token = localStorage.getItem('token');
        getSezione(data, token)
            .then((response) => {
                setCampo();
                setRegole(response.items);
                setheaderSezione(response.sezione)
            })
            .catch((error) => {
                if (error == 'Non Autorizzato') {
                    navigate('/HomeScreen');
                } else {
                    message.error(error);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const closeHandler = () => {
        if (flgRecupero) {
            Modal.warning({
                title: 'Sei sicuro di voler interrompere?',
                content: 'Se interrompi ora potresti perdere dei dati, utilizza il codice di recupero pratica per riprendere da dove hai lasciato.',
                onOk: () => {
                    if (localStorage.getItem('tokenOperatore')) {
                        navigate('/operatore/' + localStorage.getItem('tokenOperatore'));
                    }
                    else {
                        if (localStorage.getItem("praticaTotem")) {
                            localStorage.removeItem('praticaTotem');
                            navigate('/homepage', { state: { isTotem: true } })
                        }
                        else {
                            navigate('/homepage');
                        } localStorage.removeItem('id_pratica'); localStorage.removeItem('token')
                    }
                },
                closable: true,
                maskClosable: true
            });
        } else {
            Modal.warning({
                title: 'Sei sicuro di voler interrompere?',
                content: 'Se interrompi ora perderai tutti i tuoi dati inseriti fin\'ora.',
                onOk: () => {
                    if (localStorage.getItem('tokenOperatore')) {
                        navigate('/operatore/' + localStorage.getItem('tokenOperatore'));
                    }
                    else {
                        if (localStorage.getItem("praticaTotem")) {
                            localStorage.removeItem('praticaTotem');
                            navigate('/homepage', { state: { isTotem: true } })
                        }
                        else {
                            navigate('/homepage');
                        } localStorage.removeItem('id_pratica'); localStorage.removeItem('token')
                    }
                },
                closable: true,
                maskClosable: true
            });
        }
    };

    const docInformativiModal = () => {

        Modal.info({
            title: 'Documenti Informativi',
            width: innerWidth < 500 ? '95%' : '50%',
            style: {
                maxWidth: 900,
            },
            content: (
                <div style={{ fontFamily: 'Poppins-SemiBold', fontSize: 16, maxHeight: '70vh', overflowY: 'auto' }}>
                    <List
                        style={{ marginTop: '2vh', color: '#0049EA', fontFamily: 'Poppins-Regular' }}
                        // header={<div>Documenti Informativi</div>}
                        dataSource={DocInformativi}
                        renderItem={(item) => (
                            <List.Item style={{ color: '#0049EA' }}>
                                - {item}
                            </List.Item>
                        )}
                    />
                </div>
            ),
            closable: true,
            maskClosable: true,
            okButtonProps: { style: { display: 'none' } }
        });
    };

    return (
        <Layout
            style={{
                paddingTop: localStorage.getItem('nomeOperatore') ? 64 : ''
            }}>
            {innerWidth < 800 ? (
                <></>
            ) : (
                <Sider width={"27%"} style={{ backgroundColor: '#EFF4FD' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '9%' }}>
                        <div style={{ paddingTop: '7%' }}>
                            <img src={logo} alt="Banco Azzoaglio" width={'100%'} style={{ paddingRight: 15, paddingLeft: 15, maxWidth: 220 }} />
                        </div>
                        <div style={{ marginTop: '15%' }}>
                            {!loadingSezioni && sezioni && sezioni.map((sez, index) => <div key={index}>
                                <div style={{ fontFamily: 'Poppins-Medium', fontSize: 22, color: '#2574f2', marginLeft: 15, marginRight: 15 }}>
                                    {sez.processo}
                                </div>
                                <div style={{ marginTop: 30, marginLeft: 15, marginRight: 15, marginBottom: 150 }}>
                                    {sez.items && sez.items.map((item, index) => <div key={index}
                                        // style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingBottom: 10 }}
                                        style={{ fontFamily: item.flg_firmato == 1 ? 'Poppins-SemiBold' : 'Poppins-Regular', cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 30, paddingBottom: 8 }}
                                    >
                                        <div
                                            id={item.etichetta}
                                            style={{ cursor: item.successo ? "pointer" : "default", fontFamily: item.successo ? 'Poppins-SemiBold' : 'Poppins-Regular', fontSize: 18, color: item.successo ? '#003897' : '#707070', }}
                                            onClick={() => { if (item.successo) { sezioneHandler(item.id) } }}>
                                            {item.etichetta}
                                        </div>
                                        <div style={{ borderRadius: 20, width: 10, height: 10, backgroundColor: item.successo ? '#0847B2' : '#E0E1E5', position: 'absolute', right: 20 }} />
                                    </div>)
                                    }
                                </div>
                            </div>)
                            }
                            {loadingSezioni &&
                                <div>
                                    <LoadingOutlined style={{ fontSize: "64px", color: "#023AAE", marginLeft: 20 }} />
                                </div>
                            }
                        </div>
                        <div style={{ position: 'absolute', bottom: 30, marginLeft: 15, marginRight: 15 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer', marginBottom: 30 }}
                                onClick={docInformativiModal}>
                                <SvgDoc />
                                <div style={{ fontFamily: 'Poppins-Regular', fontSize: 14, color: '#0049EA', marginLeft: 10 }}>Leggi Documenti Informativi</div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer' }}
                                onClick={closeHandler}>
                                <div style={{ fontFamily: 'Poppins-Regular', fontSize: 13, color: '#0049EA', textDecoration: 'underline' }}>
                                    Torna alla Home</div>
                            </div>
                        </div>
                    </div>
                </Sider>
            )

            }

            <Content style={{ overflowY: stopScroll ? 'hidden' : 'auto', backgroundColor: 'white' }}>
                {
                    localStorage.getItem('nomeOperatore') &&
                    <Header style={{
                        backgroundColor: "#003897",
                        display: "flex",
                        justifyContent: "center",
                        marginRight: innerWidth > 1000 ? '15%' : '0%',
                        position: 'fixed',
                        width: '100%',
                        zIndex: 100,
                        left: 0,
                        top: 0,
                        height: 64
                    }}>

                        <div style={{ color: "white", fontFamily: "Poppins-Regular", fontSize: 18, }}>
                            Matricola: {localStorage.getItem('matricolaOperatore')} - {localStorage.getItem('nomeOperatore')} - {localStorage.getItem('nomeFiliale')}
                        </div>

                    </Header>
                }
                {innerWidth < 800 &&
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'row', backgroundColor: 'rgb(0, 56, 151)', color: 'white', height: '6vh', alignItems: 'center' }}>
                            <div> <img src={logo2} alt="Banco Azzoaglio" width={'100%'} style={{ maxWidth: 140, marginLeft: 10 }} /></div>
                            <div style={{
                                position: 'absolute',
                                right: '55px'
                            }} onClick={docInformativiModal}><FileTextOutlined style={{ fontSize: "20px", color: "white" }} /></div>
                            <div onClick={closeHandler} style={{
                                position: 'absolute',
                                right: '15px'
                            }}><HomeOutlined style={{ fontSize: "20px", color: "white" }} /></div>
                        </div>
                        <div style={{ height: '4vh', backgroundColor: 'rgb(239, 244, 253)', color: 'rgb(0, 56, 151)', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                            <div onClick={() => {
                                setSezioniMobile(!sezioniMobile);
                            }} style={{ cursor: 'pointer' }}>{headerSezione && headerSezione.etichetta ? headerSezione.etichetta : 'Sezioni'}</div>
                            <div onClick={() => {
                                setSezioniMobile(!sezioniMobile);
                            }} >
                                {sezioniMobile ? (
                                    <CaretUpOutlined style={{ fontSize: "16px", color: "rgb(112, 112, 112)", marginLeft: 10, cursor: 'pointer' }} />
                                ) : (
                                    <CaretDownOutlined style={{ fontSize: "16px", color: "rgb(112, 112, 112)", marginLeft: 10, cursor: 'pointer' }} />
                                )
                                }
                            </div>
                        </div>
                        {sezioniMobile &&
                            <div style={{ position: 'absolute', height: '60vh', zIndex: 40, backgroundColor: 'rgb(239, 244, 253)', width: '100vw', padding: 20, borderBottomLeftRadius: 15, borderBottomRightRadius: 15 }}>
                                <div style={{
                                    overflowY: 'auto', height: '55vh'
                                }}>
                                    {!loadingSezioni && sezioni && sezioni.map((sez, index) => <div key={index}>
                                        <div style={{ fontFamily: 'Poppins-Medium', fontSize: 22, color: '#2574f2', marginLeft: 15, marginRight: 15 }}>
                                            {sez.processo}
                                        </div>
                                        <div style={{ marginTop: 30, marginLeft: 15, marginRight: 15, marginBottom: 150 }}>
                                            {sez.items && sez.items.map((item, index) => <div
                                                key={index}
                                                // style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingBottom: 10 }}
                                                style={{ fontFamily: item.flg_firmato == 1 ? 'Poppins-SemiBold' : 'Poppins-Regular', cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 30, paddingBottom: 8 }}
                                            >
                                                <div style={{ borderRadius: 20, width: 10, height: 10, backgroundColor: item.successo ? '#0847B2' : '#E0E1E5', marginRight: 10 }} />
                                                <div
                                                    id={item.etichetta}
                                                    style={{ cursor: item.successo ? "pointer" : "default", fontFamily: item.successo ? 'Poppins-SemiBold' : 'Poppins-Regular', fontSize: 18, color: item.successo ? '#003897' : '#707070', }}
                                                    onClick={() => { if (item.successo) { sezioneHandler(item.id); setSezioniMobile(!sezioniMobile) } }}>
                                                    {item.etichetta}
                                                </div>
                                            </div>)
                                            }
                                        </div>
                                    </div>)
                                    }
                                    {loadingSezioni &&
                                        <div>
                                            <LoadingOutlined style={{ fontSize: "44px", color: "#023AAE", display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
                                        </div>
                                    }
                                </div>
                            </div>}
                    </div>
                }
                <div className="pol-content"
                    style={{ height: polContentHeight, backgroundColor: ' white', paddingLeft: '5%' }}>
                    {regole &&
                        <>

                            <div>
                                <FormOnboarding regole={regole} headerSezione={headerSezione} loading={loading} setSezioneCompiled={setSezioneCompiled} loadingSetSezioni={loadingSetSezioni} setFile={setFile} />
                                <div style={{ height: 10 }} />
                            </div>
                        </>
                    }
                </div>
            </Content>
            {innerWidth > 1000 &&
                <div id="onboarding-gradient-right" style={{ backgroundColor: '#EFF4FD', position: 'fixed', right: 15, bottom: 0, width: '15%', height: '100vh', zIndex: 1 }} >
                    <div className="process-companion animation fadein-right-long animate-only-this" style={{ width: '100%', position: 'absolute', top: 0, right: '15%', translate: '0 50%' }}>
                        <SvgOnboarding />
                    </div>
                </div>
            }
        </Layout>
    );
};

export default OnboardingScreen;
